module.exports = {
  model: { id: '', customer_id: null, date: '' },
}
